/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Rating from 'react-rating';
import {
    Button,
    Col,
    Container,
    Row,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Spinner,
    Label,
    // Input,
} from 'reactstrap';
import { ICartProduct, IProduct, IProductVariant, IReview } from '@ddot/AddToCartCommon/lib/entities';

import { Heart, CartBag, HeartFilled, Unlike, CartBagBlue } from 'Icons/Icons';
import ErrorMessage from 'Components/Common/ErrorMessage';

import { IAddToCartThunkParams } from 'Redux/slices/cart/controllers/addToCart';

import Utils from 'Lib/Utils';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';
import { RootState } from 'Redux/store';
import { IGoldPrice } from 'Redux/slices/home/Entities';

// import LoginOrSignupModal from '../../User/LoginSignUpModal';
import LoginSignUpModal from 'Containers/User/LoginSignUpModal';
import VariantSelector from './VariantSelector';
import ProductImage from './ProductImage';
import NavActions from '../../../Services/Navigation/Actions';
import {
    addToCartButtonContainer,
    addToCartButton,
    buttonIcons,
    checkoutButton,
    productDetailsContainer,
    productDetailsText,
    productName,
    // productNoteText,
    productPrice,
    productDropdown,
    productPurityText,
    // productDescriptionTitle,
    // productDescription,
    productVariationText,
    productLaborChargeMsg,
    // remarkInput,
    wishlistButton,
    filledWishlistButton,
    quantityContainer,
    shareContainer,
    buttonContainer,
} from '../Styles/ProductDetailsStyles';

interface IProductDetails {
    product: IProduct;
    reviews?: IReview[];
    reviewIndex?: number;
    similarProducts?: IProduct[];
}

interface ProductProps {
    productDetails: IProductDetails;
    loading: boolean;
    error: string;
    wishlist: IProduct[];
    goldPrice: IGoldPrice;
    clearError(): void;
    addToWishlistLocalWeb(item: IProduct): void;
    addToCart(item: IAddToCartThunkParams): void;
    isLoggedIn: string | undefined;
    getWishlist(): void;
    removeFromWishlistLocalWeb(product: IProduct): void;
}

const ProductDetailsRow = (props: ProductProps) => {
    const { productDetails, loading, error, wishlist, goldPrice, isLoggedIn, getWishlist, removeFromWishlistLocalWeb, addToCart } = props;

    useEffect(() => {
        return () => {
            const { clearError } = props;
            clearError();
        };
    }, []);

    const { product, reviews } = productDetails;

    const {
        imageUrl,
        imageFileNames,
        name,
        id,
        // description,
        currency,
        // overallReviewStars,
        customAttributes,
    } = product;

    const [selectedVariant, setSelectedVariant] = useState<IProductVariant | undefined>(undefined);
    const [quantityDropdownOpen, setQuantityDropdownOpen] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [remarks, setRemarks] = useState('');
    // const [modal, setModal] = useState(false);
    const [loginModalVisible, setLoginModalVisible] = useState(false);

    const toggleQuantityDropdown = () => setQuantityDropdownOpen((prevState) => !prevState);

    const { minPrice, maxPrice } = Utils.Jemisys.getItemPriceRange(product, goldPrice);
    const purity = Utils.Product.getPurity(customAttributes);
    const availableQuantity = Utils.Product.getAvailableQuantity(product);

    const onAddToWishlist = () => {
        const { addToWishlistLocalWeb } = props;

        if (isLoggedIn) {
            if (wishlist.includes(product)) {
                removeFromWishlistLocalWeb(product);
            } else addToWishlistLocalWeb(product);
        } else setLoginModalVisible(true);
    };

    const onAuthorized = () => {
        setLoginModalVisible(false);
    };

    const onSignup = () => {
        setLoginModalVisible(true);
    };

    const onAddToCart = () => {
        addToCart({ product, selectedVariant, quantity, remarks });
    };

    const shareUrl = `https://tiansi.doubleplayground.com/product/${product.id}`;

    const openShareFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, 'targetWindow',
            `toolbar=no,
            location=no,
            status=no,
            menubar=no,
            scrollbars=yes,
            resizable=yes,
            width=600,
            height=300`);
    };

    const openShareWhatsapp = () => {
        window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`, 'targetWindow',
            `toolbar=no,
            location=no,
            status=no,
            menubar=no,
            scrollbars=yes,
            resizable=yes,
            width=600,
            height=300`);
    };

    const openInstagram = async () => {
        // alert('Link copied! Paste it in your Instagram story or message.');

        // await navigator.clipboard.writeText(shareUrl);

        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(shareUrl);
            } catch {
                // alert('Clipboard access denied.');
            }
        } else {
            // Fallback for older browsers & iOS Safari
            const textArea = document.createElement('textarea');
            textArea.value = shareUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        alert('Link copied! Paste it in your Instagram story or message.');
        window.open('https://www.instagram.com/', 'targetWindow',
            `toolbar=no,
            location=no,
            status=no,
            menubar=no,
            scrollbars=yes,
            resizable=yes,
            width=600,
            height=300`);
    };

    const directCheckout = () => {
        if (isLoggedIn) {
            if (Utils.Product.getSalesType(product.customAttributes) === 'JEWELERY') {
                addToCart({ product, selectedVariant, quantity, remarks });
                NavActions.navToShippingAddress();
            } else if (Utils.Product.getSalesType(product.customAttributes) === 'GOLD') {
                if (selectedVariant) {
                    addToCart({ product, selectedVariant, quantity, remarks });
                    NavActions.navToShippingAddress();
                } else addToCart({ product, selectedVariant, quantity, remarks });
            }
        } else setLoginModalVisible(true);
    };

    // const renderReview = () => {
    //     return (
    //         <Row css={productRatingRow}>
    //             <Col xs='auto'>
    //                 <Rating
    //                     initialRating={overallReviewStars}
    //                     emptySymbol={
    //                         <StarEmpty css={productRatingStars} />
    //                     }
    //                     fullSymbol={
    //                         <StarFilled css={productRatingStars} />
    //                     }
    //                     readonly
    //                 />
    //                 <span css={productRatingText}>(120)</span>
    //             </Col>
    //         </Row>
    //     );
    // };

    const renderPricing = () => {
        let price = '';

        if (!selectedVariant) {
            const min = `${Number(minPrice).toFixed(2)} ${currency}`;
            const max = `${Number(maxPrice).toFixed(2)} ${currency}`;

            if (maxPrice !== minPrice) {
                price = `${min} - ${max}`;
            } else price = max;
        } else {
            price = `${Utils.Jemisys.getItemVariantPrice(product, selectedVariant, goldPrice)} ${currency}`;
        }

        return (
            <div>
                <div css={productPrice}>
                    {price}
                </div>

                <div css={productLaborChargeMsg}>
                    *Price includes labour cost
                </div>
            </div>
        );
    };

    const renderAddToWishlistButton = () => {
        useEffect(() => {
            if (isLoggedIn) getWishlist();
        }, []);

        if (loading) {
            return (
                <div>
                    <Spinner color='primary' />
                </div>
            );
        }

        if (wishlist.includes(product)) {
            return (
                <div>
                    <ErrorMessage error={error ? ' ' : ''} style={{ alignItems: 'flex-start', marginTop: 15 }} />
                    <Button
                        onClick={onAddToWishlist}
                        onKeyPress={onAddToWishlist}
                        role='button'
                        tabIndex={0}
                        css={checkoutButton}
                    >
                        Remove
                        <Unlike css={buttonIcons} />
                    </Button>
                </div>

            );
        }

        return (
            <div>
                <ErrorMessage error={error ? ' ' : ''} style={{ alignItems: 'flex-start', marginTop: 15 }} />
                <Button
                    onClick={onAddToWishlist}
                    onKeyPress={onAddToWishlist}
                    role='button'
                    tabIndex={0}
                    css={checkoutButton}
                >
                    Save To Wishlist
                    <Heart css={buttonIcons} />
                </Button>
            </div>

        );
    };

    const renderAddToCartButtons = () => {
        if (loading) {
            return (
                <div css={addToCartButtonContainer}>
                    <Spinner color='#064E72' />
                </div>
            );
        }

        return (
            <div>
                <ErrorMessage error={error} style={{ alignItems: 'flex-start', marginTop: 15 }} />
                <Button
                    onClick={onAddToCart}
                    css={addToCartButton}
                >
                    Add To Cart
                    <CartBagBlue className='cartBlue' />
                    <CartBag className='cart' />
                </Button>
            </div>
        );
    };

    return (
        <Container fluid css={productDetailsContainer}>
            <Row>
                <Col xs={12} md={6} lg={6}>
                    <ProductImage images={imageFileNames?.length ? imageFileNames : imageUrl} />
                </Col>
                <Col xs={12} md={6} lg={6}>
                    <div css={productName}>{product.name}</div>

                    <div><p style={{ margin: 0 }}>{product.id}</p></div>

                    {renderPricing()}

                    <div style={{ paddingTop: 40 }}>
                        <VariantSelector
                            selectedVariant={selectedVariant}
                            product={product}
                            onVariantSelected={setSelectedVariant}
                            title
                            type='details'
                        />
                    </div>

                    <div css={quantityContainer}>
                        <div css={productDetailsText}>Quantity</div>
                        <Dropdown isOpen={quantityDropdownOpen} toggle={toggleQuantityDropdown} disabled={availableQuantity <= 1}>
                            <DropdownToggle css={productDropdown} caret>
                                {quantity}
                            </DropdownToggle>
                            <DropdownMenu>
                                {Array.from({ length: availableQuantity }, (x, i) => i + 1).map((x) => (
                                    <DropdownItem
                                        css={productVariationText}
                                        key={x}
                                        onClick={() => setQuantity(x)}
                                    >
                                        {x}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>

                        <p style={{ color: '#616161', fontFamily: 'AcuminRPro', fontStyle: 'italic', fontSize: '1.2rem' }}>
                            Availability:
                            {' '}
                            {availableQuantity}
                            {' '}
                            in stock
                        </p>
                    </div>

                    <div css={buttonContainer}>
                        {renderAddToCartButtons()}

                        {renderAddToWishlistButton()}
                    </div>

                    <div css={shareContainer}>
                        <p>Share On: </p>

                        <div>
                            <div
                                aria-label='share on whatsapp'
                                role='button'
                                tabIndex={0}
                                onClick={openShareWhatsapp}
                                onKeyPress={openShareWhatsapp}
                            >
                                <img src='/assets/icons/Whatsapp.svg' alt='' />
                            </div>

                            <div
                                aria-label='share on facebook'
                                role='button'
                                tabIndex={0}
                                onClick={openShareFacebook}
                                onKeyPress={openShareFacebook}
                            >
                                <img src='/assets/icons/Facebook2.svg' alt='' />
                            </div>

                            <div
                                aria-label='share on instagram'
                                role='button'
                                tabIndex={0}
                                onClick={openInstagram}
                                onKeyPress={openInstagram}
                            >
                                <img src='/assets/icons/Instagram2.svg' alt='' />
                            </div>
                        </div>
                    </div>

                </Col>
            </Row>

            <LoginSignUpModal
                show={() => setLoginModalVisible(true)}
                hide={() => setLoginModalVisible(false)}
                modal={loginModalVisible}
                onAuthorized={onAuthorized}
                onSignup={onSignup}
            />

            {/* <LoginOrSignupModal modal={modal} onAuthorized={onAuthorized} onSignup={onSignup} /> */}
        </Container>
    );
};

const mapStateToProps = (state: RootState) => ({
    loading: Selectors.getCartAddToCartAttempting(state),
    error: Selectors.getCartAddToCartError(state),
    goldPrice: Selectors.getHomeGoldPrice(state),
    wishlist: Selectors.getUserWishlist(state),
    isLoggedIn: Selectors.getAuthAuthToken(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    addToCart: (item: IAddToCartThunkParams) => dispatch(Actions.cartAddToCart(item)),
    addToWishlistLocalWeb: (product: IProduct) => dispatch(Actions.userAddToWishListLocalWeb({ product })),
    clearError: () => dispatch(Actions.cartClearAddToCartError()),
    getWishlist: () => dispatch(Actions.userGetWishlistLocalWeb()),
    removeFromWishlistLocalWeb: (product: IProduct) => dispatch(Actions.userRemoveFromWishlistLocalWeb({ product })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailsRow);
